type Data = {
  question: string,
  answer: string
}

const data: Data[] = [
  {
    question: "Is cider beer?",
    answer: `
      Cider is not beer, even though it has a similar alcohol content and
      both undergo a fermentation process. Cider is made throgh the
      fermentation of apple or pear juice and it does not contain any hops,
      wheat or malt.
    `
  },
  {
    question: "Is cider gluten free?",
    answer: `
      Somersby cider is gluten-free. During the production we don't use
      wheat or cereal-based ingredients that would usually be a source
      of gluten. Only our beer-based cider in Poland, which we call
      Somersby Apple Beer Drink contains gluten because it is based on
      beer. All our normal ciders are free of gluten though.
    `
  },
  {
    question: "Is cider alcoholic?",
    answer: `
      Somersby cider contains 4.5% alcohol. Our cider undergoes a
      fermentation process, in which alcohol is a natural byproduct.
      The strength of our cider is comparable with a typical lager beer.
    `
  },
  {
    question: "Is cider vegan?",
    answer: `
    The vast majority of our ciders is made from vegan-friendly 
    ingredients. That is unless they contain carmine, which is found in 
    Blackberry, Red Rhubarb, Sparkling Rosé and Sparkling Spritz. It is 
    easy to spot if a Somersby contains carmine (E120) on the nutritional 
    facts label, usually on the backside of the packaging.
    `
  },
  {
    question: "Does cider have carbs?",
    answer: `
      Somersby ciders contain from about 3.9 grams up to 8.7 grams of 
      carbohyrdates per 100ml. Our Somersby sparkling white contains the
      lowest amount of carbs, with 3.9 gras per 100ml.
    `
  }
]

export default data;